<template>
  <div @click="onClick" class="select-menu-entry" :class="{ active: active }" ref="selectMenuEntry">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, ref } from "vue";

const selectMenuEntry = ref<HTMLElement | null>(null);

/* const props = */ defineProps<{ active?: boolean }>();
const emit = defineEmits(["click"]);

const instance = getCurrentInstance();

const onClick = () => {
  if (instance && instance.parent && instance.parent.exposed && instance.parent.exposed.hide) instance.parent.exposed.hide();
  emit("click");
};
</script>
